var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPushLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 6.45 2.45 6 3 6C3.55 6 4 6.45 4 7V17C4 17.55 3.55 18 3 18C2.45 18 2 17.55 2 17V7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8825 17.29C11.2725 17.68 11.9025 17.68 12.2925 17.29C12.6825 16.9 12.6825 16.27 12.2925 15.88L9.41251 13H20.5825C21.1325 13 21.5825 12.55 21.5825 12C21.5825 11.45 21.1325 11 20.5825 11H9.41251L12.2925 8.12002C12.6825 7.73002 12.6725 7.09002 12.2925 6.70002C11.9025 6.31002 11.2725 6.31002 10.8825 6.70002L6.29251 11.29C5.90251 11.68 5.90251 12.31 6.29251 12.7L10.8825 17.29Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPushLeft);
export default __webpack_public_path__ + "static/media/ico-push-left.cdaf23b272c5fb512918e4dad50e382e.svg";
export { ForwardRef as ReactComponent };